import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import bindersLogo from '../assets/binders-logo.png';
import './TopRibbon.css';

const TopRibbon: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  // Determine active tab based on current path
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="top-ribbon">
      <div className="ribbon-content">
        <div className="ribbon-brand" onClick={() => navigate('/roles')} style={{ cursor: 'pointer' }}>
          <img src={bindersLogo} alt="Binders" className="ribbon-logo" />
        </div>
        <div className="ribbon-nav">
          <button
            onClick={() => navigate('/roles')}
            className={`ribbon-nav-item ${isActive('/roles') ? 'active' : ''}`}
          >
            Roles
          </button>
          <button
            onClick={() => navigate('/resume-bank')}
            className={`ribbon-nav-item ${isActive('/resume-bank') ? 'active' : ''}`}
          >
            Resume Bank
          </button>
        </div>
        <div className="ribbon-actions">
          <span className="ribbon-user">{user?.name || user?.email}</span>
          <button onClick={handleLogout} className="ribbon-logout">
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopRibbon;
